<template>
  <svg
    class="progress_indicator"
    :class="{ 'progress_indicator--animation-enabled': animationEnabled }"
  >
    <rect
      class="progress_indicator__frame"
      width="100%"
      height="100%"
      fill="transparent"
      :stroke-dashoffset="400 - indicatorPercentage * 400 + '%'"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProgressFrameBar',

  props: {
    indicatorPercentage: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      animationEnabled: true,
    };
  },

  watch: {
    indicatorPercentage: {
      immediate: true,
      async handler(indicatorPercentage, oldIndicatorPercentage) {
        if (indicatorPercentage !== oldIndicatorPercentage && indicatorPercentage === 0) {
          this.animationEnabled = false;
          await this.$nextTick();
          this.animationEnabled = true;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.progress_indicator {
  position: fixed;
  top: env(safe-area-inset-top);
  left: 0;
  height: calc(100% - env(safe-area-inset-top));
  width: 100%;

  // disable click events on indicator
  pointer-events: none;
}

.progress_indicator__frame {
  stroke: $color-purple;
  stroke-width: 5px;
  stroke-dasharray: 400%;
}

.progress_indicator--animation-enabled .progress_indicator__frame {
  transition: 1s linear;
}
</style>
